<template>
  <div class="shell-page">
    <HeaderMain @messageFromHeader="searchEvents" />

    <div v-if="requestUserStatus === false || requestUserStatus === 'false'">
      <DisabledAccount />
    </div>

    <div v-else>
      <SlideShow :main="title" :subtitle="subtitle" :type="1" />
      <SearchCourse v-if="!main" :courses="search" />

      <div v-if="err" class="shell-empty-state">
        No encontramos resultados para este host. Prueba con otra busqueda o vuelve mas tarde.
      </div>

      <section class="shell-section" style="padding-top: 38px; padding-bottom: 48px;">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Host</span>
          <h2 class="section-heading__title">Eventos de {{ hostLabel }}</h2>
          <p class="section-heading__text">
            Revisa las fechas activas y entra directo al detalle de cada evento.
          </p>
        </div>
      </section>

      <EventCard v-show="main" :host="host" />
      <EventCard v-if="!main" :eventsProp="search" :host="host" />
      <FooterMain />
    </div>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import SlideShow from '@/components/SlideShow.vue'
import SearchCourse from '@/components/SearchCourse.vue'
import DisabledAccount from '@/components/DisabledAccount.vue'
import FooterMain from '@/components/FooterMain.vue'
import EventCard from '@/components/EventCard.vue'

export default {
  name: 'HostEventView',

  props: {
    host: {
      required: true,
    },
  },

  components: {
    HeaderMain,
    SlideShow,
    SearchCourse,
    DisabledAccount,
    FooterMain,
    EventCard,
  },

  data() {
    return {
      search: [],
      searchField: '',
      main: true,
      err: false,
      requestUserStatus: false,
      requestUserType: false,
      subtitle: '',
      title: '',
    }
  },

  computed: {
    hostLabel() {
      return this.host ? this.host.replace(/-/g, ' ') : 'este host'
    },
  },

  methods: {
    searchEvents(results, term) {
      this.search = results
      this.searchField = term

      if (this.searchField !== '') {
        if (this.search.length !== 0) {
          this.main = false
          this.err = false
        } else {
          this.main = true
          this.err = true
        }
      } else {
        this.main = true
        this.err = false
      }
    },

    setUserData() {
      this.requestUserStatus = window.localStorage.getItem('is_active')
      this.requestUserType = window.localStorage.getItem('is_gold')
    },
  },

  created() {
    if (this.host === 'microteatro') {
      this.title = 'Microteatro UIO en cartelera'
      this.subtitle = 'Funciones, horarios y cupos en una vista clara y directa.'
    } else {
      this.title = `${this.hostLabel.toUpperCase()} EN CARTELERA`
      this.subtitle = `Eventos de ${this.hostLabel} con acceso rapido a fechas, cupos y compra.`
    }

    this.setUserData()
  },
}
</script>

<style>
</style>
